import React, { useRef } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import ContactBadge from './ContactBadge';
import './ProgramView.css';
import { useReactToPrint } from 'react-to-print';
import { FaPrint,FaBarcode } from 'react-icons/fa';
import CourseVisualBlock from './CourseVisualBlock';
export default function ProgramView(props) {
  
  const programRef = useRef();
 
  const handlePrint = useReactToPrint({
    content: () => programRef.current,
    documentTitle: props.data?.name || 'Program Report',
  });
  if (!props.data) {
    return <><h1 className="programInformation">Program Information</h1><p>No parogram selected</p></>; // Handle undefined or null data gracefully
  }
console.log(props.data?.relatedFrameworks)
  return (
    <div  ref={programRef}>
      <Row>
        <Col lg="12" md="12" sm="12" sx="12" className="programInformation">
          Program Information <button title="Print" onClick={handlePrint} className="btn btn-primary printButton" style={{ marginTop: '20px' }}><FaPrint /></button>
        </Col>
      </Row>

      {props.data.name !== undefined ? (
        <div className="viewContainer">
          <Row className="programIfoBlock">
           
            <Col className="programInformation">{props.data?.name}</Col>
          
            
            <Col lg="12" md="12" sm="12" sx="12" className="viewValue">{props.data?.description}</Col>
            <h5 style={{textAlign:"right"}} title={props.data?.level?.description}><Badge pill >{props.data?.level?.name}</Badge></h5>
          </Row>
       
          <Row>
            <Col lg="12" md="12" sm="12" sx="12" className="viewLabel">Stakeholders:</Col>
            <Col>
              {props.data.stakeholders?.map((stakeholder, index) => {
                return (
                  <ContactBadge
                    key={index}
                    data={stakeholder}
                    columnsNames={[
                      { label: 'Full Name', columnDBName: 'fullName' },
                      { label: 'Organization', columnDBName: 'organization' },
                      { label: 'Email', columnDBName: 'email' },
                      { label: 'Tel', columnDBName: 'phoneNumber' },
                      { label: 'Role', columnDBName: 'role' },
                      { label: 'Mapping', columnDBName: 'mapping' }
                    ]}
                  />
                );
              })}
            </Col>
          </Row>
          <Row>
            <Col lg="12" md="12" sm="12" sx="12" className="viewLabel">Audience Profile</Col>
          </Row>
          <Row>
            <Col lg="11" md="11" sm="11" sx="11">
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Audience</Col>
                <Col className="viewValue">{props.data.audience?.who}</Col>
              </Row>
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Background Knowledge</Col>
                <Col className="viewValue">{props.data.audience?.backgroundKnowledge}</Col>
              </Row>
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Technology Comfort Level:</Col>
                <Col>
                  <input type="range" min="0" max="5" value={props.data.audience?.technologyComfortLevel} step="1" readOnly />
                  <Badge className="bigBadge" bg="secondary">{props.data.audience?.technologyComfortLevel}/5</Badge>
                </Col>
              </Row>
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Math Comfort Level:</Col>
                <Col>
                  <input type="range" min="0" max="5" value={props.data.audience?.mathComfortLevel} step="1" readOnly />
                  <Badge className="bigBadge" bg="secondary">{props.data.audience?.mathComfortLevel}/5</Badge>
                </Col>
              </Row>
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Age (From-To):</Col>
                <Col>
                  <input type="range" min="1" max="110" value={props.data.audience?.ageFrom} step="1" readOnly />
                  <Badge className="bigBadge" bg="secondary">{props.data.audience?.ageFrom}</Badge>
                  <input type="range" min="1" max="110" value={props.data.audience?.ageTo} step="1" readOnly />
                  <Badge className="bigBadge"  bg="secondary">{props.data.audience?.ageTo}</Badge>
                </Col>
              </Row>
              <Row>
                <Col lg="4" md="4" sm="5" sx="12" className="viewLabelLight">Preferred Delivery Method</Col>
                <Col className="viewValue">{props.data.audience?.preferedDeliveryMethod}</Col>
              </Row>
              <Row>
                <Col lg="12" md="12" sm="12" sx="12" className="viewLabel">
                Created to fully or partially cover the competencis of the following frameworks
                </Col>
              </Row>
              <Row>
                <Col lg="12" md="12" sm="12" sx="12" className="viewValue">
                {props.data.relatedFrameworks?.map((relatedFramework, index) => {
                  return( 
                  <div key={index+"framwwork"}>
                    <div className="programFrameworkName">{relatedFramework.frameworkName}</div>
                    <div className="programFrameworkDescription">{relatedFramework.frameworkDescription}</div>
                  
                  </div>




                  );
                })}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Row>
                    <Col lg="12" md="12" sm="12" sx="12" className="viewLabel">Program's Courses</Col>
                  </Row>
                  <Row>
                    {props.data.courses?.map((course, index) => {
                      return (
                       
                          <CourseVisualBlock
                          course={course}
                          index={index}
                          />
                       
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      ) : (
        <div>
          <Row>
            <Col>Please select a program</Col>
          </Row>
        </div>
      )}

      
    </div>
  );
}
